@if (pdfUrl) {
  <section class="privacy-policy-page">
    <div class="privacy-policy-actions">
      <button class="privacy-policy-action-button" type="button" (click)="goBack()">
        {{ 'PRIVACY_POLICY_PAGE.GO_BACK' | translate }}
      </button>
      <a [href]="pdfUrl" [attr.target]="openLinkTarget" class="privacy-policy-action-button" rel="noopener noreferrer">
        {{ 'PRIVACY_POLICY_PAGE.OPEN_DOCUMENT' | translate }}
      </a>
    </div>
    @if (shouldRenderInlineViewer) {
      <object class="privacy-policy-frame" [data]="safePdfUrl" type="application/pdf">
        <iframe
          class="privacy-policy-frame"
          [src]="safePdfUrl"
          [title]="'PRIVACY_POLICY_PAGE.TITLE' | translate"></iframe>
      </object>
    } @else {
      <div class="privacy-policy-fallback">
        <div class="privacy-policy-fallback-card">
          <h1 class="privacy-policy-title">{{ 'PRIVACY_POLICY_PAGE.TITLE' | translate }}</h1>
          <p class="privacy-policy-text">{{ 'PRIVACY_POLICY_PAGE.MOBILE_DESCRIPTION' | translate }}</p>
        </div>
      </div>
    }
  </section>
} @else {
  <div class="privacy-policy-fallback">{{ 'PRIVACY_POLICY_PAGE.UNAVAILABLE' | translate }}</div>
}
